import * as FluxUtils from 'flux/utils';
import { AppDispatcher, DispatcherBaseAction } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { UIHelper } from '../utils/UIHelper';
import { PopupMenu, Overlay, HamburgerTab } from '../constants/Enums';

export interface DialogData {
    callback: (value: any) => void;
    label: string;
    default: string | number | null;
    type: 'text' | 'number' | 'length';
    submitLabel?: string;
    closeCallback?: () => void;
    noTextHelper?: boolean;
    clickedElement?: HTMLElement;
}

export interface LengthDialogData {
    clickedElement: HTMLElement;
    id: string;
    defaultValue: string | null;
    onSubmit: (value: number | null) => void;
    onCancel: () => void;
}

export interface DoneMessageSetting {
    label: string;
    id: string;
}

interface VisibilityState {
    overlay: Overlay;
    dialog: DialogData | null;
    lengthDialog: LengthDialogData | null;
    popupMenu: PopupMenu;
    infoMessage: string;
    doneMessage: DoneMessageSetting;
    fullscreen: boolean;
}

class VisibilityStoreClass extends FluxUtils.ReduceStore<VisibilityState, unknown> {
    protected static InitialOverlayStates: Array<Overlay> = [
        Overlay.LOGIN, Overlay.LOGIN_QUESTION
    ];

    public getInitialState(): VisibilityState {
        return {
            overlay: Overlay.PENDING,
            dialog: null,
            lengthDialog: null,
            popupMenu: PopupMenu.NONE,
            infoMessage: '',
            doneMessage: {label: '', id: 'empty'},
            fullscreen: false,
        };
    }

    public reduce(state: VisibilityState, action: DispatcherBaseAction): VisibilityState {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed

        switch (action.actionType) {
            case ActionConstants.SHOW_SELECTBOX:
                if (
                    action.value != null &&
                    action.value.asOverlay === false &&
                    action.value.options != null &&
                    action.value.options.length > 0
                ) {
                    return jQuery.extend({}, state, {
                        hamburgerTab: HamburgerTab.SETTINGS
                    });
                }
                break;
            case ActionConstants.SET_POPUPMENU:
                return {...state, popupMenu: action.value};
            case ActionConstants.RESET_PROJECT_RELATED_SETTINGS:
                if (VisibilityStoreClass.InitialOverlayStates.indexOf(state.overlay) === -1) {
                    return jQuery.extend({}, this.getInitialState(), {
                        overlay: Overlay.NONE
                    });
                }
                break;
            case ActionConstants.SET_OVERLAY:
                return jQuery.extend({}, state, {overlay: action.value.overlay});
            case ActionConstants.SET_LENGTHDIALOG:
                return jQuery.extend({}, state, {lengthDialog: action.value});
            case ActionConstants.SET_DIALOG:
                return jQuery.extend({}, state, {dialog: action.value});
            // close popup on sidebar + hamburger change
            case ActionConstants.CHANGE_SIDEBAR:
            case ActionConstants.CHANGE_HAMBURGER:
                if (state.popupMenu != null) {
                    return jQuery.extend({}, state, {popupMenu: PopupMenu.NONE});
                }
                break;
            case ActionConstants.SET_INFO_MESSAGE:
                return jQuery.extend({}, state, {infoMessage: action.value});
            case ActionConstants.SET_DONE_MESSAGE:
                return jQuery.extend({}, state, {doneMessage: {label: action.value, id: UIHelper.getUUID()}});
            case ActionConstants.SET_FULLSCREEN:
                return jQuery.extend({}, state, {fullscreen: action.value});
            default:
                break;
        }

        return state;
    }
}

export let VisibilityStore: VisibilityStoreClass = new VisibilityStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/VisibilityStore.ts